__turbopack_context__.v({
  "bottom": "stickyBox-module-scss-module__h9KZHq__bottom",
  "box": "stickyBox-module-scss-module__h9KZHq__box",
  "show": "stickyBox-module-scss-module__h9KZHq__show",
  "top": "stickyBox-module-scss-module__h9KZHq__top",
  "topDesktopBottomMobile": "stickyBox-module-scss-module__h9KZHq__topDesktopBottomMobile",
});
